import styled from 'styled-components';
import { Colors, ScreenWidth, Spacing, TransitionTime } from 'web-common/src/shared/styles';

interface TypeaheadContainerProps {
  dropdownBorder?: boolean;
}
export const TypeaheadContainer = styled.div<TypeaheadContainerProps>`
  .text-input,
  .rbt-input-main,
  .rbt-input-hint {
    border: none;
    margin: 0px 0px 0 ${Spacing.HALF} !important;
    width: inherit;
    height: 75%;
    outline: none;
    font-size: 18px !important;

    ::placeholder {
      color: $grayLight;
    }

    @media screen and (max-width: ${ScreenWidth.SMALL}) {
      margin-top: 5px;
    }

    @media screen and (max-width: ${ScreenWidth.EXTRA_SMALL}) {
      margin-top: 5px;

      ::placeholder {
        font-size: 90%;
      }
    }
  }

  .rbt {
    background-color: rgb(247, 247, 247) !important;
    flex: 1;
    margin-right: 0;

    .rbt-input-wrapper {
      align-items: center;
      padding: calc(${Spacing.SINGLE} - ${Spacing.EIGHTH}) !important;
      margin-top: 0px !important;
      margin-bottom: 0px !important;
    }

    .rbt-token {
      background-color: $grayMid;
      color: black;
      margin: ${Spacing.EIGHTH};
      padding: ${Spacing.HALF} ${Spacing.SINGLE_THREE_QUARTERS} ${Spacing.HALF} ${Spacing.HALF};

      .rbt-token-remove-button {
        top: 0;
        height: 100%;
        padding: ${Spacing.QUARTER} ${Spacing.HALF} !important;
        border-top-right-radius: 2px;
        border-bottom-right-radius: 2px;
        transition: background-color ${TransitionTime.BASE};

        &:hover {
          background-color: ${Colors.GRAY_DARK_10};
        }
      }
    }

    .dropdown-item {
      font-size: 16px !important;
      mark,
      .mark {
        padding: 0;
      }
    }

    .is-invalid {
      border: 1px solid $errorRed !important;
    }

    /**** THE FOLLOWING SECTION IS COPY AND PASTED OUT OF BOOSTRAP4.css ***/
    /*** I thought it would be easier to use some elements from boostrap then to use all of boostrap and to style
  ** to our style. Gross, but it's gross either way.
  **/
    // The dropdown wrapper (div)
    .dropup,
    .dropright,
    .dropdown,
    .dropleft {
      position: relative;
    }

    // The dropdown menu
    .dropdown-menu {
      position: absolute;
      top: 100%;
      left: 0;
      display: none; // none by default, but block on "open" of the menu
      float: left;
      border-radius: 0px;
      box-shadow: none;
      border: ${({ dropdownBorder }) => (dropdownBorder ? '1px solid black' : 'none')};
      padding-left: 0px;

      text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)
      list-style: none;
      background-clip: padding-box;
    }

    // Allow for dropdowns to go bottom up (aka, dropup-menu)
    // Just add .dropup after the standard .dropdown class and you're set.
    .dropup {
      .dropdown-menu {
        top: auto;
        bottom: 100%;
        margin-top: 0;
      }
    }

    .dropright {
      .dropdown-menu {
        top: 0;
        right: auto;
        left: 100%;
        margin-top: 0;
      }
    }

    .dropleft {
      .dropdown-menu {
        top: 0;
        right: 100%;
        left: auto;
        margin-top: 0;
      }
    }

    // When enabled Popper.js, reset basic dropdown position
    // stylelint-disable-next-line no-duplicate-selectors
    .dropdown-menu {
      &[x-placement^='top'],
      &[x-placement^='right'],
      &[x-placement^='bottom'],
      &[x-placement^='left'] {
        right: auto;
        bottom: auto;
      }
    }

    // Dividers (basically an hr) within the dropdown
    .dropdown-divider {
      height: 0;
      margin: 2px 0;
      overflow: hidden;
      border-top: 1px solid white;
    }

    // Links, buttons, and more within the dropdown menu
    //
    // button-specific styles are denoted with // For buttons
    .dropdown-item {
      display: block;
      width: 100%; // For buttons
      padding: 2px 0px 2px ${Spacing.HALF};
      clear: both;
      text-align: inherit; // For buttons
      white-space: nowrap; // prevent links from randomly breaking onto new lines
      background-color: transparent; // For buttons
      border: 0; // For buttons

      &.active,
      &:active {
        &,
        & .rbt-highlight-text {
          background-color: ${Colors.AQUA};
          color: ${Colors.WHITE};
          text-decoration: none;
        }
      }

      &.disabled,
      &:disabled {
        pointer-events: none;
        background-color: transparent;
      }
    }

    .dropdown-menu.show {
      display: block;
    }
  }

  .text-input-container,
  .rbt-input-multi {
    width: 400px;
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    height: unset !important;
    min-height: 50px !important;
    box-shadow: none !important;
    border: 0px !important;
    padding: 0px !important;

    flex: 5;
    margin-right: 10px;
    @media screen and (max-width: ${ScreenWidth.SMALL}) {
      margin-right: 0;
      width: 100%;
    }
    @media screen and (max-width: ${ScreenWidth.EXTRA_SMALL}) {
      width: 90vw;
      height: 50px;

      .zip-input {
        font-size: 2.7vw;
        line-height: 4vw;
      }
    }
  }

  .rbt-input-multi {
    background-color: transparent !important;
    width: 100%;
  }

  .rbt,
  .text-input-container {
    max-width: 100%;
    @media screen and (max-width: ${ScreenWidth.SMALL}) {
      max-width: 90%;
    }
  }
`;

export const TypeaheadContainerCompact = styled(TypeaheadContainer)`
  .text-input,
  .rbt-input-main,
  .rbt-input-hint {
    margin: 0px 0px 0 ${Spacing.HALF} !important;
    font-size: 16px !important;
  }

  .rbt {
    .rbt-token {
      font-size: 12px;
    }
    .rbt-input-wrapper {
      padding: ${Spacing.HALF} !important;
    }
    .rbt-input-multi {
      min-height: ${Spacing.TRIPLE} !important;
    }
  }
`;
